var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-1 overflow-hidden",staticStyle:{"border-radius":"10px"},attrs:{"id":"gantt_container"}})
}
var staticRenderFns = []

export { render, staticRenderFns }